import axios from "axios";

const getAddressLatLong = async (
  address,
  expectedCity,
  expectedState,
  expectedPostalCode = null
) => {
  let completeAddress = `${address},${expectedCity},${expectedState},${expectedPostalCode}`;
  try {
    const response = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json`,
      {
        params: {
          address: completeAddress,
          key: process.env.REACT_APP_GOOGLE_MAP_API_KEY, // Your backend API key for geocoding
        },
      }
    );

    if (response.data.status === "OK") {
      const results = response.data.results;
      if (results.length === 0) throw new Error("No geocoding results found.");

      const normalize = (s) =>
        String(s || "")
          .toLowerCase()
          .trim();

      for (const result of results) {
        let city = null,
          state = null,
          postalCode = null;

        for (const component of result.address_components) {
          if (component.types.includes("postal_code")) {
            postalCode = component.long_name;
          }
          if (
            component.types.includes("locality") ||
            component.types.includes("sublocality")
          ) {
            city = component.long_name;
          }
          // if (component.types.includes("administrative_area_level_1")) {
          //   state = component.long_name;
          // }
        }
        const cityMatch = normalize(city) === normalize(expectedCity);
        // const stateMatch = normalize(state) === normalize(expectedState);
        const postalMatch = expectedPostalCode
          ? normalize(postalCode) === normalize(expectedPostalCode)
          : true;

        if (
          cityMatch || //stateMatch &&
          postalMatch
        ) {
          return {
            lat: result.geometry.location.lat,
            lng: result.geometry.location.lng,
            // formatted_address: result.formatted_address,
          };
        }
      }
      const location = response.data.results[0].geometry.location;
      return location; // { lat, lng }
    } else {
      return {
        success: false,
        error: "Address not found!!",
      };
    }
  } catch (error) {
    console.error(`Error in geocoding address ${address}:`, error);
    throw new Error("Geocoding failed");
  }
};

export default getAddressLatLong;
